function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function wishlist() {
  var cookieName = "wishlistList";
  $(document).on(
    "click",
    ".addto-wishlist, .removefrom-wishlist",
    function (e) {
      e.preventDefault();
      var id = $(this).attr("rel");
      var didFindRel = false;
      if (getCookie(cookieName) == null) {
        var str = "__" + id;
        didFindRel = true;
      } else {
        if (getCookie(cookieName).indexOf(id) == -1) {
          var str = getCookie(cookieName) + "__" + id;
          str = str.replace("____", "__");
          didFindRel = false;
        }else{
          // l'ha trovato, devo rimuoverlo dalla lista
          var str = getCookie(cookieName).replace("__" + id, "");
        }
      }
      setCookie(cookieName, str, 30);
      setTimeout(() => {
        updateWishlist();
      }, 200);
    }
  );
}

function updateWishlist() {
  var cookieName = "wishlistList";
  try {
    if (
      getCookie(cookieName) != null &&
      getCookie(cookieName) != "__" &&
      getCookie(cookieName) != ""
    ) {
      var str = String(getCookie(cookieName))
        .split("__")
        .filter((s) => s !== "");
      $(".favCount").text(str.length).removeClass("hide");
      $(".btn.wishlist").removeClass("ad-circle-notch-r");

      str.forEach((id) => {
        $('.wishlist[rel="' + id + '"]')
          .removeClass("addto-wishlist")
          .addClass("removefrom-wishlist")
          .addClass("ad-circle-notch-r");
      });
    } else {
      $(".btn.wishlist").removeClass("ad-circle-notch-r");
      $(".favCount").text(0).removeClass("hide");
    }
  } catch (err) {}
}

$(document).ready(() => {
  wishlist();
  updateWishlist();
});

